<template>
    <div class="datetime-picker">
        <span class="datetime-icon">
            <font-awesome-icon icon="calendar" />
        </span>
        <input v-if="format.includes('m')" @input="changeDate" @keyup="checkNext($event, 'day')" ref="month" v-model="month" :class="['datetime-input', monthValid() ? 'error' : '']" type="text" placeholder="MM" maxlength="2" />/
        <input v-if="format.includes('d')" @input="changeDate" @keyup="checkNext($event, 'year')" ref="day" v-model="day" :class="['datetime-input', daysValid() ? 'error' : '']" type="text" placeholder="DD" maxlength="2" />/
        <input v-if="format.includes('y')" @input="changeDate" ref="year" v-model="year" class="datetime-input year" type="text" placeholder="YYYY" maxlength="4" />
    </div>
</template>
<script>
export default {
    name    :   "dt-picker",
    props   :   {
                    value   :   String,
                    format  :   {
                                    type    : String,
                                    default : "mdy"
                                }
                },
    mounted ()  {
                    // Sets the default value.
                    if (typeof this.value == "string") {
                        this.applyChange(this.value);
                    }
                },
    data    ()  {
                    return {
                        month       :   "",
                        day         :   "",
                        year        :   "",
                        hour        :   "",
                        minutes     :   "",
                        am_or_pm    :   ""
                    };
                },
    watch   :   {
                    value (newVal, oldVal) {
                        this.applyChange(newVal);
                    }
                },
    methods :   {
                    applyChange (value)     {
                                                if (typeof value != "string") value = "--";
                                                var [year, month, day] = value.split(/-/g);
                                                this.year   = year;
                                                this.month  = month;
                                                this.day    = day;
                                            },
                    monthValid ()           {
                                                return (parseInt(this.month) > 12);
                                            },
                    daysValid ()            {
                                                return (parseInt(this.day) > this.daysInMonth(this.month));
                                            },
                    checkValid ()           {
                                                return this.monthValid() && this.daysValid();
                                            },
                    checkNext (evt, next)   {
                                                var e = evt.target;
                                                if (e.value.length == e.getAttribute('maxlength')) {
                                                    this.$refs[next].focus();
                                                }
                                            },
                    changeDate ()           {
                                                var date = [this.year, this.month, this.day];
                                                this.$emit("valid", this.checkValid(), date.join('-'));
                                                this.$emit("input", date.join('-'));
                                            },
                    daysInMonth (month)     {
                                                return new Date((this.year || 2009), month, 0).getDate();
                                            }
                }
}
</script>
<style scoped>
    .datetime-picker {
        margin: 0px;
        padding: 0px;
        padding-left: 10px;
        border-radius: 5px;
        border: 1px solid #EBE9ED;
    }
    .datetime-icon {
        margin-right: 2%;
    }
    .datetime-input {
        width: 40px;
        text-align: center;
        margin: 4px 0px;
        border: none;
        font-size: 16px;
        padding-bottom: 3px;
    }
    .datetime-input:disabled {
        background-color: lightgrey;
    }
    .datetime-input.error {
        outline: none;
        border: none;
        border-bottom: 3px solid red;
        padding-bottom: 0px;
    }
    .datetime-input.year {
        width: 60px;
    }
    .datetime-input:not(.error):focus {
        outline: none;
        border: none;
        border-bottom: 3px solid #007bff;
        padding-bottom: 0px;
    }
    .datetime-popup {
        display: none;
        position: fixed;
        left: 25%;
        top: 25%;
        background-color: purple;
        color: white;
        font-family: 'Courier New', Courier, monospace;
    }
    .datetime-popup.visible {
        display: block;
    }
    ul.datetime-selector {
        list-style-type: none;
        min-width: 300px;
        margin: 0px;
        padding: 20px;
    }
    ul.datetime-selector .title {
        border-bottom: 1px solid black;
    }
    ul.datetime-selector .footer {
        border-top: 1px solid black;
        float: right;
    }
    ul.datetime-selector .footer button {
        background-color: transparent;
        color: white;
        border: none;
        outline: none;
    }
    ul.datetime-selector .footer button:hover {
        font-weight: bold;
    }
    .datetime-option {
        cursor: pointer;
    }
    .datetime-option.selected {
        font-weight: bold;
    }
    .datetime-option.selected:before {
        content: "\00BB";
        margin-right: 10px;
    }
</style>